import { useEffect } from 'react';
import type { JSX } from 'react';

import { Button, Text } from '@change/ds-core-ui';
import { PlayArrowIcon } from '@change/ds-icons';

import { Translate } from '@change-corgi/core/react/i18n';

import { useHeroVideoButton } from './hooks';

export function PageHeading(): JSX.Element {
	const {
		data: { shouldShowVideoOnLoad },
		actions: { handleButtonClick, showVideo },
	} = useHeroVideoButton();
	useEffect(() => {
		if (shouldShowVideoOnLoad) {
			showVideo();
		}
	}, [shouldShowVideoOnLoad, showVideo]);

	return (
		<div className="container mb-10">
			<Text variant="heading" size="x-large" as="h1" className="mb-6 capitalize">
				<Translate value="fe.pages.impact.title" />
			</Text>
			<Button
				className="mt-4"
				variant="secondary"
				onClick={handleButtonClick}
				leadingIcon={<PlayArrowIcon />}
				data-qa="heading-video"
			>
				<Translate value="fe.pages.impact.video_btn" />
			</Button>
		</div>
	);
}
